import type { ReactNode } from 'react'

export default function SiteShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-white text-[#131a54]">
      <main>{children}</main>
    </div>
  )
}
